import {
  type LeadErrors,
  type LeadForm,
  validateLeadForm,
} from "./contact-lead";

export { type LeadErrors, type LeadForm, validateLeadForm };

export const moduleIds = [
  "loyalty",
  "pos",
  "orders",
  "tables",
  "reservations",
  "inventory",
  "supply",
  "invoice",
] as const;

export type ModuleId = (typeof moduleIds)[number];

export const officialContacts = {
  privacy: "contact@collectie.io",
  support: "contact@collectie.io",
} as const;

export type OfficialRoute =
  | "home"
  | "privacy"
  | "support"
  | "terms"
  | "notFound";

export function resolveOfficialRoute(pathname: string): OfficialRoute {
  const path = pathname.replace(/\/+$/, "") || "/";
  if (path === "/") return "home";
  if (path === "/privacy") return "privacy";
  if (path === "/support") return "support";
  if (path === "/terms") return "terms";
  return "notFound";
}

export const privacySections = [
  {
    id: "scope",
    paragraphs: ["body", "coverage"],
    bullets: [],
  },
  {
    id: "data",
    paragraphs: ["intro"],
    bullets: [
      "identity",
      "loyalty",
      "wallet",
      "merchant",
      "technical",
      "support",
      "website",
      "minimization",
    ],
  },
  {
    id: "uses",
    paragraphs: ["intro"],
    bullets: ["service", "wallet", "security", "support", "contact", "legal", "improve"],
  },
  {
    id: "bases",
    paragraphs: ["intro"],
    bullets: ["contract", "legitimate", "obligation", "consent", "taiwan"],
  },
  {
    id: "sharing",
    paragraphs: ["intro"],
    bullets: [
      "merchants",
      "cloudflare",
      "apple",
      "google",
      "law",
      "change",
      "noSale",
    ],
  },
  {
    id: "transfers",
    paragraphs: ["body"],
    bullets: ["safeguards"],
  },
  {
    id: "retention",
    paragraphs: ["intro"],
    bullets: [
      "active",
      "deletion",
      "records",
      "support",
      "analytics",
      "websiteLeads",
    ],
  },
  {
    id: "choices",
    paragraphs: ["intro"],
    bullets: ["account", "location", "wallet", "website", "marketing"],
  },
  {
    id: "rights",
    paragraphs: ["intro"],
    bullets: ["eu", "taiwan", "request", "complaint"],
  },
  {
    id: "security",
    paragraphs: ["body", "limits"],
    bullets: [],
  },
  {
    id: "changes",
    paragraphs: ["body", "contact"],
    bullets: [],
  },
] as const;

export const supportTopics = [
  "wallet",
  "rewards",
  "account",
  "deletion",
  "merchant",
] as const;

export const termsSections = [
  {
    id: "agreement",
    paragraphs: ["body", "eligibility"],
    bullets: [],
  },
  {
    id: "service",
    paragraphs: ["intro"],
    bullets: ["membership", "separation", "availability", "noPayment"],
  },
  {
    id: "accounts",
    paragraphs: ["intro"],
    bullets: ["accuracy", "security", "devices", "recovery"],
  },
  {
    id: "rewards",
    paragraphs: ["intro"],
    bullets: ["merchantRules", "server", "corrections", "noValue"],
  },
  {
    id: "wallet",
    paragraphs: ["body"],
    bullets: ["apple", "updates", "removal"],
  },
  {
    id: "acceptable",
    paragraphs: ["intro"],
    bullets: ["law", "access", "interference", "fraud", "credentials"],
  },
  {
    id: "content",
    paragraphs: ["intro"],
    bullets: ["collectie", "merchant", "feedback"],
  },
  {
    id: "merchants",
    paragraphs: ["body", "contract"],
    bullets: [],
  },
  {
    id: "suspension",
    paragraphs: ["body"],
    bullets: ["user", "collectie", "records"],
  },
  {
    id: "disclaimers",
    paragraphs: ["body", "mandatory"],
    bullets: [],
  },
  {
    id: "liability",
    paragraphs: ["body", "exclusions", "mandatory"],
    bullets: [],
  },
  {
    id: "law",
    paragraphs: ["body", "resolution"],
    bullets: [],
  },
  {
    id: "changes",
    paragraphs: ["body", "continued"],
    bullets: [],
  },
  {
    id: "contact",
    paragraphs: ["body", "privacy"],
    bullets: [],
  },
] as const;
